import React from "react";
import { ActionButton } from "../../shared";
import { Icons } from "../../shared/Icons";

interface AdminPageHeaderWithBackProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  onBackClick?: () => void;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonDisabled?: boolean;
  buttonLoading?: boolean;
  buttonVariant?: "primary" | "success";
}

export const AdminPageHeaderWithBack: React.FC<
  AdminPageHeaderWithBackProps
> = ({
  icon,
  title,
  subtitle,
  onBackClick,
  buttonText,
  onButtonClick,
  buttonDisabled = false,
  buttonLoading = false,
  buttonVariant = "primary",
}) => {
  return (
    <div className="bg-white dark:!bg-slate-800 rounded-xl sm:rounded-2xl shadow-medium border border-gray-100 dark:border-slate-700 p-4 sm:p-5 md:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
        <div className="flex items-center gap-2 sm:gap-4 min-w-0">
          {onBackClick && (
            <button
              onClick={onBackClick}
              className="p-2 text-gray-600 dark:text-slate-300 hover:text-gray-800 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-colors duration-200 shrink-0"
              title="Voltar"
            >
              <Icons.ArrowBack sx={{ fontSize: 24 }} />
            </button>
          )}
          <span className="flex items-center shrink-0 [&>.MuiSvgIcon-root]:!text-2xl sm:[&>.MuiSvgIcon-root]:!text-3xl">{icon}</span>
          <div className="min-w-0">
            <h2 className="text-lg sm:text-2xl font-bold text-gray-900 dark:text-white truncate">{title}</h2>
            <p className="text-sm sm:text-base text-gray-600 dark:text-slate-300 mt-0.5 sm:mt-1 line-clamp-2">{subtitle}</p>
          </div>
        </div>
        {buttonText && onButtonClick && (
          <ActionButton
            onClick={onButtonClick}
            disabled={buttonDisabled}
            loading={buttonLoading}
            variant={buttonVariant === "success" ? "success" : "primary"}
            size="sm"
            icon={buttonLoading ? "⏳" : buttonVariant === "success" ? "💾" : "➕"}
          >
            {buttonText}
          </ActionButton>
        )}
      </div>
    </div>
  );
};
